import { formatDate } from '../../dateUtils';
import { TEDDisplayDate } from '../Displayers/TEDDisplayDate';
import { ParseResult, IParseResult, ValueType } from '../FormatterTypes';
import { BaseValidator } from './BaseValidator';

class TEDValidateDate extends BaseValidator {
  public static getInstance(): BaseValidator {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: BaseValidator;

  defaultParams(): string {
    return '';
  }

  validate(value: ValueType, params?: string): IParseResult {
    const pickedDate = new Date(value as string);
    pickedDate.setHours(0, 0, 0, 0);
    let splitArray = params?.split(/;| /);

    let result = differenceDatesAndValidInterval(splitArray, pickedDate);

    return {
      value: result.value,
      result: result.error,
      preFix: result.preFix,
    };
  }

  errorMessage(
    value: ValueType,
    parseResult: IParseResult,
    displayer: TEDDisplayDate,
    params: string = '',
    displayerParams: string = '',
    caption: string = '',
    preFix: string = ''
  ): string {
    if (parseResult.result > ParseResult.OK) {
      if (preFix === '+') {
        return `${caption} måste vara ${value} eller tidigare`;
      } else {
        return `${caption} måste vara ${value} eller senare`;
      }
    } else if (parseResult.result < ParseResult.OK) {
      if (preFix === '+') {
        return `${caption} borde vara ${value} eller tidigare`;
      } else {
        return `${caption} borde vara ${value} eller senare`;
      }
    } else {
      return '';
    }
  }
}

interface IValue {
  value: string;
  isMonths: boolean;
}

interface IValidationDate {
  date: Date | undefined;
  preFix: string;
}

const extractValue = (str: string): IValue => {
  let values: IValue = { value: '', isMonths: false };
  let typeOfValue = str[str.length - 2].toUpperCase();

  if (typeOfValue === 'M') {
    let months = str.substring(str.indexOf('"') + 1, str.lastIndexOf('m'));
    values = {
      value: months,
      isMonths: true,
    };
    return values;
  } else {
    let days = str.substring(str.indexOf('"') + 1, str.lastIndexOf('d'));
    values = {
      value: days,
      isMonths: false,
    };

    return values;
  }
};

const extractPreFix = (str: string): string => {
  let substr = '+';

  if (str.includes(substr)) {
    return substr;
  } else {
    return '-';
  }
};

const getParamDate = (param: string): IValidationDate => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  let date: Date;
  let preFix: string = extractPreFix(param);

  const values = extractValue(param);
  if (values.isMonths) {
    const valueNumber = Number.parseInt(values.value, 10);
    date = new Date(currentDate.setMonth(currentDate.getMonth() + valueNumber));
  } else {
    const valueNumber = Number.parseInt(values.value, 10);
    date = new Date(currentDate.setDate(currentDate.getDate() + valueNumber));
  }
  return { date, preFix };
};

const differenceDatesAndValidInterval = (
  splitArray: string[] | undefined,
  pickedDate: Date
) => {
  let value: any = {};
  let maxDateObject: IValidationDate = {
    date: undefined,
    preFix: '',
  };
  let minDateObject: IValidationDate = {
    date: undefined,
    preFix: '',
  };
  let maxRecommendedDateObject: IValidationDate = {
    date: undefined,
    preFix: '',
  };
  let minRecommendedDateObject: IValidationDate = {
    date: undefined,
    preFix: '',
  };
  let error: ParseResult = ParseResult.OK;
  let preFix: string = '';

  splitArray?.map((element: string) => {
    if (/MaxDate/.test(element)) {
      maxDateObject = getParamDate(element);
    } else if (/MinDate/.test(element)) {
      minDateObject = getParamDate(element);
    } else if (/MaxRecommendedDate/.test(element)) {
      maxRecommendedDateObject = getParamDate(element);
    } else if (/MinRecommendedDate/.test(element)) {
      minRecommendedDateObject = getParamDate(element);
    }
  });

  if (maxDateObject.date && pickedDate > maxDateObject.date) {
    value = formatDate(maxDateObject.date);
    error = ParseResult.ERROR;
    preFix = maxDateObject.preFix;
  } else if (
    maxRecommendedDateObject.date &&
    pickedDate > maxRecommendedDateObject.date
  ) {
    value = formatDate(maxRecommendedDateObject.date);
    error = ParseResult.WARNING;
    preFix = maxRecommendedDateObject.preFix;
  }

  if (minDateObject.date && pickedDate < minDateObject.date) {
    value = formatDate(minDateObject.date);
    error = ParseResult.ERROR;
    preFix = minDateObject.preFix;
  } else if (
    minRecommendedDateObject.date &&
    pickedDate < minRecommendedDateObject.date
  ) {
    value = formatDate(minRecommendedDateObject.date);
    error = ParseResult.WARNING;
    preFix = minRecommendedDateObject.preFix;
  }

  return { value, error, preFix };
};

export { TEDValidateDate };
